export enum ObjectSubTypes {
  Risk = 1,
  Issue = 2,
  Opportunity = 3,
  Sub_Task = 4,
}
